import * as React from 'react';
import { Component } from 'react';
import { IDiseaseCategory } from '../../models/IDiseaseCategory';
import { IEducation } from '../../models/IEducation';
import { ITrainingCourse } from '../../models/ITrainingCourse';
import { AboutMeComponent } from './AboutMe';
import { TrainingCoursesComponent } from './TrainingCourses';
import { EducationComponent } from './Education';
import { DiseaseCategoriesComponent } from './DiseaseCategories';
import { IDropDownItem } from '../../models/IDropDownItem';
import { ITherapy } from '../../models/ITherapy';
import { TherapiesComponent } from './Therapies';
import { CertificationsComponent } from './Certifications';
import { IUserFile } from '../../models/IUserFile';
import { PicturesComponent } from './Pictures';
import { LanguagesComponent } from './Languages';
import { PhysiotherapistService } from '../../services/PhysiotherapistService';
import { LanguageService } from '../../services/LanguageService';
import { UserFileService } from '../../services/UserFileService';
import { TherapyService } from '../../services/TherapyService';
//import { SearchService } from '../../services/SearchService';
import { EducationService } from '../../services/EducationService';
import { DiseaseCategoryService } from '../../services/DiseaseCategoryService';
import { TrainingCourseService } from '../../services/TrainingCourseService';
import { IInternship } from '../../models/IInternship';
import { InternshipsComponent } from './Internships';
import { InternshipService } from '../../services/InternshipService';
import './PhysiotherapistView.css'


interface IProps {
    ShowExperienceSection: boolean,
    ShowSpecializationSection: boolean,
    PhysiotherapistId?: string
}

interface IState {
    RedirectToEducationEdit: boolean,
    DiseaseCategories: IDiseaseCategory[],
    Therapies: ITherapy[],
    AllDiseaseCategories: IDropDownItem[],
    AllTherapies: IDropDownItem[],
    Education: IEducation[],
    Internships: IInternship[],
    TrainingCourses: ITrainingCourse[],
    Certifications: IUserFile[],
    Pictures: IUserFile[],
    Languages: string[],
    UpdatedAboutMe?: string,
    ClinicsNumber: number,
    AboutMe?: string,
    Specialization?: string
}

export class PhysiotherapistInfoComponent extends Component<IProps, IState> {
    constructor(props) {
        super(props);

        this.state = {
            RedirectToEducationEdit: false,
            DiseaseCategories: [],
            Therapies: [],
            AllDiseaseCategories: [],
            AllTherapies: [],
            Education: [],
            Internships: [],
            TrainingCourses: [],
            Certifications: [],
            Pictures: [],
            Languages: [],
            AboutMe: undefined,
            ClinicsNumber: 0,
            Specialization: undefined
        }

        this.FullRefresh = this.FullRefresh.bind(this);
        this.OnFullRefreshSuccess = this.OnFullRefreshSuccess.bind(this);
        this.OnFullRefreshError = this.OnFullRefreshError.bind(this);
        this.RefreshPhysiotherapistsBasicInfo = this.RefreshPhysiotherapistsBasicInfo.bind(this);
        this.OnGetBasicInfoSuccess = this.OnGetBasicInfoSuccess.bind(this);
        this.OnGetBasicInfoError = this.OnGetBasicInfoError.bind(this);
        this.OnGetDiseaseCateogoriesSuccess = this.OnGetDiseaseCateogoriesSuccess.bind(this);
        this.OnGetDiseaseCateogoriesError = this.OnGetDiseaseCateogoriesError.bind(this);
        this.OnGetEducationSuccess = this.OnGetEducationSuccess.bind(this);
        this.OnGetEducationError = this.OnGetEducationError.bind(this);
        this.RefreshDiseaseCategories = this.RefreshDiseaseCategories.bind(this);
        this.RefreshEducation = this.RefreshEducation.bind(this);
        this.RefreshTrainingCourses = this.RefreshTrainingCourses.bind(this);
        this.OnGetTrainingCoursesSuccess = this.OnGetTrainingCoursesSuccess.bind(this);
        this.OnGetTrainingCoursesError = this.OnGetTrainingCoursesError.bind(this);
        this.RefreshEducation = this.RefreshEducation.bind(this);
        //this.GetAllCategories = this.GetAllCategories.bind(this);
        //this.OnGetAllCategoriesSuccess = this.OnGetAllCategoriesSuccess.bind(this);
        //this.OnGetAllCategoriesError = this.OnGetAllCategoriesError.bind(this);
        this.RefreshTherapies = this.RefreshTherapies.bind(this);
        this.OnGetTherapiesSuccess = this.OnGetTherapiesSuccess.bind(this);
        this.OnGetTherapiesError = this.OnGetTherapiesError.bind(this);
        this.RefreshCertifications = this.RefreshCertifications.bind(this);
        this.OnGetCertificationsSuccess = this.OnGetCertificationsSuccess.bind(this);
        this.OnGetCertificationsError = this.OnGetCertificationsError.bind(this);
        this.RefreshPictures = this.RefreshPictures.bind(this);
        this.OnGetPicturesSuccess = this.OnGetPicturesSuccess.bind(this);
        this.OnGetPicturesError = this.OnGetPicturesError.bind(this);
        this.RefreshLanguages = this.RefreshLanguages.bind(this);
        this.OnGetLanguagesSuccess = this.OnGetLanguagesSuccess.bind(this);
        this.OnGetLanguagesError = this.OnGetLanguagesError.bind(this);
        this.FullRefresh = this.FullRefresh.bind(this);
        this.OnFullRefreshSuccess = this.OnFullRefreshSuccess.bind(this);
        this.OnFullRefreshError = this.OnFullRefreshError.bind(this);
        this.RefreshInternships = this.RefreshInternships.bind(this);
        this.OnGetInternshipsSuccess = this.OnGetInternshipsSuccess.bind(this);
        this.OnGetInternshipsError = this.OnGetInternshipsError.bind(this);

        this.FullRefresh(this.props.PhysiotherapistId);
    }

    public componentWillReceiveProps(nextProps: IProps) {
        if (this.props.PhysiotherapistId !== nextProps.PhysiotherapistId) {
            this.FullRefresh(nextProps.PhysiotherapistId);
        }
    }

    public render() {
        return (
            <div className="physiotherapist-info-component">
                {this.RenderExperienceSection()}
                {this.RenderSpecializationSection()}
            </div>
        );
    }//end-of-render

    private RenderExperienceSection() {
        if (this.props.ShowExperienceSection) {
            if (this.props.PhysiotherapistId === undefined ||
                (!this.IsAboutMeNullOrEmpty()) ||
                this.state.TrainingCourses.length > 0 ||
                this.state.Certifications.length > 0 ||
                (!this.IsSpecializationNullOrEmpty()) ||
                this.state.Education.length > 0 ||
                this.state.Pictures.length > 0 ||
                this.state.Languages.length > 0
            ) {
                return (
                    <div className="section experience">
                        <h2>Doświadczenie</h2>
                        <div className="form-container">
                            {this.RenderAboutMeSection()}
                            {this.RenderTrainingCoursesSection()}
                            {this.RenderCertificationsSection()}
                            {this.RenderSpecialization()}
                            {this.RenderInternshipsSection()}
                            {this.RenderEducationSection()}
                            {this.RenderLanguagesSection()}
                            {this.RenderPicturesSection()}
                        </div>
                    </div>
                );
            } else {
                return null;
            }
        } else {
            return null;
        }
    }

    private RenderAboutMeSection() {
        let aboutMeSection = (
            <AboutMeComponent
                IsEditMode={this.props.PhysiotherapistId ? false : true}
                AboutMe={this.state.AboutMe}
                OnRefreshRequired={this.RefreshPhysiotherapistsBasicInfo} />
        );
        if (this.props.PhysiotherapistId === undefined) {
            return aboutMeSection;
        }
        if (!this.IsAboutMeNullOrEmpty()) {
            return aboutMeSection;
        } else {
            return null;
        }
    }

    private IsAboutMeNullOrEmpty(): boolean {
        if (this.state.AboutMe !== undefined && this.state.AboutMe !== null) {
            if (this.state.AboutMe.length > 0) {
                return false;
            } else {
                return true;
            }
        } else {
            return true;
        }
    }

    private RenderTrainingCoursesSection() {
        let trainingCoursesSection = (
            <TrainingCoursesComponent
                IsEditMode={this.props.PhysiotherapistId ? false : true}
                TrainingCourses={this.state.TrainingCourses}
                OnRefreshRequired={this.RefreshTrainingCourses} />
        );
        if (this.props.PhysiotherapistId === undefined) {
            return trainingCoursesSection;
        }
        if (this.state.TrainingCourses.length > 0) {
            return trainingCoursesSection;
        } else {
            return null;
        }
    }

    private RenderCertificationsSection() {
        let certificationsSection = (
            <CertificationsComponent
                IsEditMode={this.props.PhysiotherapistId ? false : true}
                OnRefreshRequired={this.RefreshCertifications}
                Certifications={this.state.Certifications} />
        );
        if (this.props.PhysiotherapistId === undefined) {
            return certificationsSection;
        }
        if (this.state.Certifications.length > 0) {
            return certificationsSection;
        } else {
            return null;
        }
    }

    private RenderInternshipsSection() {
        let internshipsSection = (
            <InternshipsComponent
                Internships={this.state.Internships}
                IsEditMode={this.props.PhysiotherapistId ? false : true}
                OnRefreshRequired={this.RefreshInternships}/>
        );
        if (this.props.PhysiotherapistId === undefined) {
            return internshipsSection;
        }
        if (this.state.Internships.length > 0) {
            return internshipsSection;
        } else {
            return null;
        }
    }

    private RenderEducationSection() {
        let educationSection = (
            <EducationComponent
                IsEditMode={this.props.PhysiotherapistId ? false : true}
                Education={this.state.Education}
                OnRefreshRequired={this.RefreshEducation} />
        );
        if (this.props.PhysiotherapistId === undefined) {
            return educationSection;
        }
        if (this.state.Education.length > 0) {
            return educationSection;
        } else {
            return null;
        }
    }

    private RenderPicturesSection() {
        let picturesSection = (
            <PicturesComponent
                IsEditMode={this.props.PhysiotherapistId ? false : true}
                Pictures={this.state.Pictures}
                OnRefreshRequired={this.RefreshPictures} />
        );
        if (this.props.PhysiotherapistId === undefined) {
            return picturesSection;
        }
        if (this.state.Pictures.length > 0) {
            return picturesSection;
        } else {
            return null;
        }
    }

    private RenderLanguagesSection() {
        let languagesSection = (
            <LanguagesComponent
                IsEditMode={this.props.PhysiotherapistId ? false : true}
                Languages={this.state.Languages}
                OnRefreshRequired={this.RefreshLanguages} />
        );
        if (this.props.PhysiotherapistId === undefined) {
            return languagesSection;
        }
        if (this.state.Languages.length > 0) {
            return languagesSection;
        } else {
            return null;
        }
    }

    private RenderSpecializationSection() {
        if (this.props.ShowSpecializationSection) {
            if (this.props.PhysiotherapistId === undefined ||
                this.state.DiseaseCategories.length > 0 ||
                this.state.Therapies.length > 0
            ) {
                return (
                    <div className="section specializations">
                        <h2>Specjalności</h2>
                        <div className="form-container">
                            {this.RenderTherapiesSection()}
                            {this.RenderDiseaseCateogoriesSection()}
                        </div>
                    </div>
                );
            } else {
                return null;
            }
        } else {
            return null;
        }
    }

    private RenderDiseaseCateogoriesSection() {
        let diseaseCategoriesSection = (
            <DiseaseCategoriesComponent
                DiseaseCategories={this.state.DiseaseCategories}
                IsEditMode={this.props.PhysiotherapistId ? false : true}
                OnRefreshRequired={this.RefreshDiseaseCategories}
                AllDiseaseCategories={this.state.AllDiseaseCategories} />
        );
        if (this.props.PhysiotherapistId === undefined) {
            return diseaseCategoriesSection;
        }
        if (this.state.DiseaseCategories.length > 0) {
            return diseaseCategoriesSection;
        } else {
            return null;
        }
    }

    private RenderTherapiesSection() {
        let therapiesSection = (
            <TherapiesComponent
                Therapies={this.state.Therapies}
                AllTherapies={this.state.AllTherapies}
                OnRefreshRequired={this.RefreshTherapies}
                IsEditMode={this.props.PhysiotherapistId ? false : true} />
        );
        if (this.props.PhysiotherapistId === undefined) {
            return therapiesSection;
        }
        if (this.state.Therapies.length > 0) {
            return therapiesSection;
        } else {
            return null;
        }
    }

    private RenderSpecialization() {
        let specializationSection = (this.state.Specialization !== null && this.state.Specialization !== undefined && this.state.Specialization !== '') ?
            (<div className="form-row">
                <label>Specjalizacja:</label>
                <ul>
                    <li className="specialization-list">{this.state.Specialization}</li>
                </ul>
            </div>) :
            null;
        if (this.props.PhysiotherapistId === undefined) {
            return specializationSection;
        }
        if (!this.IsSpecializationNullOrEmpty()) {
            return (
                specializationSection
            );
        } else {
            return null;
        }
    }

    private IsSpecializationNullOrEmpty() {
        if (this.state.Specialization === undefined || this.state.Specialization === null) {
            return true;
        } else {
            if (this.state.Specialization.length > 0) {
                return false;
            } else {
                return true;
            }
        }
    }

    private FullRefresh(physiotherapistId?: string) {
        let service = new PhysiotherapistService();
        if (physiotherapistId) {
            service.GetPhysiotherapistsProfile(
                physiotherapistId,
                this.OnFullRefreshSuccess,
                this.OnFullRefreshError);
        } else {
            service.GetMyProfile(this.OnFullRefreshSuccess, this.OnFullRefreshError);
        }
    }

    private OnFullRefreshSuccess(result) {
        this.setState({
            AboutMe: result.data.Value.PhysiotherapistInfo.AboutMe,
            Specialization: result.data.Value.PhysiotherapistInfo.Specialization,

            DiseaseCategories: result.data.Value.DiseaseCategories,
            Education: result.data.Value.Education,
            TrainingCourses: result.data.Value.TrainingCourses,
            Therapies: result.data.Value.Therapies,
            Certifications: result.data.Value.Certifications,
            Pictures: result.data.Value.Pictures,
            Languages: result.data.Value.Languages,
            Internships: result.data.Value.Internships,
            AllDiseaseCategories: result.data.Value.AllCategories.DiseaseCategories
                .map((category: IDiseaseCategory) => {
                    return {
                        Id: category.Id,
                        Value: category.Name
                    } as IDropDownItem;
                }),
            AllTherapies: result.data.Value.AllCategories.Therapies
                .map((category: ITherapy) => {
                    return {
                        Id: category.Id,
                        Value: category.Name
                    } as IDropDownItem;
                })
        });
    }

    private OnFullRefreshError(error) {
        console.error(error);
    }

    private RefreshLanguages() {
        let service = new LanguageService();
        if (this.props.PhysiotherapistId) {
            service.GetPhysiotherapistsLanguages(
                this.props.PhysiotherapistId,
                this.OnGetLanguagesSuccess,
                this.OnGetLanguagesError);
        } else {
            service.GetMyLanguages(this.OnGetLanguagesSuccess, this.OnGetLanguagesError);
        }
    }

    private OnGetLanguagesSuccess(result) {
        this.setState({
            Languages: result.data.Value
        });
    }

    private OnGetLanguagesError(error) {
        console.error(error);
    }

    private RefreshPictures() {
        let service = new UserFileService();
        if (this.props.PhysiotherapistId) {
            service.GetPhysiotherapistsPictures(
                this.props.PhysiotherapistId,
                this.OnGetPicturesSuccess,
                this.OnGetPicturesError);
        } else {
            service.GetMyPictures(
                this.OnGetPicturesSuccess,
                this.OnGetPicturesError);
        }
    }

    private OnGetPicturesSuccess(result) {
        this.setState({
            Pictures: result.data.Value
        });
    }

    private OnGetPicturesError(error) {
        console.error(error);
    }

    private RefreshCertifications() {
        let service = new UserFileService();
        if (this.props.PhysiotherapistId) {
            service.GetPhysiotherapistsCertifications(
                this.props.PhysiotherapistId,
                this.OnGetCertificationsSuccess,
                this.OnGetCertificationsError);
        } else {
            service.GetMyCertifications(
                this.OnGetCertificationsSuccess,
                this.OnGetCertificationsError);
        }
    }

    private OnGetCertificationsSuccess(result) {
        this.setState({
            Certifications: result.data.Value
        });
    }

    private OnGetCertificationsError(error) {
        console.error(error);
    }

    private RefreshTherapies() {
        let service = new TherapyService();
        if (this.props.PhysiotherapistId) {
            service.GetAllPhysiotherapistsTerapies(
                this.props.PhysiotherapistId,
                this.OnGetTherapiesSuccess,
                this.OnGetTherapiesError);
        } else {
            service.GetAllMyTherapies(this.OnGetTherapiesSuccess, this.OnGetTherapiesError);
        }
    }

    private OnGetTherapiesSuccess(result) {
        this.setState({
            Therapies: result.data.Value
        });
    }

    private OnGetTherapiesError(error) {
        console.error(error);
    }

    //private GetAllCategories() {
    //    let service = new SearchService();
    //    service.GetAllCategories(this.OnGetAllCategoriesSuccess, this.OnGetAllCategoriesError);
    //}

    //private OnGetAllCategoriesSuccess(result) {
    //    let diseases: IDropDownItem[];
    //    diseases = [];
    //    result.data.Value.DiseaseCategories.forEach((item) => {
    //        diseases.push({
    //            Id: item.Id,
    //            Value: item.Name
    //        });
    //    });
    //    let therapies: IDropDownItem[];
    //    therapies = [];
    //    result.data.Value.Therapies.forEach((item) => {
    //        therapies.push({
    //            Id: item.Id,
    //            Value: item.Name
    //        });
    //    });
    //    this.setState({
    //        AllDiseaseCategories: diseases,
    //        AllTherapies: therapies
    //    });
    //}

    //private OnGetAllCategoriesError(error) {
    //    console.error(error);
    //}

    private RefreshEducation() {
        let educationService = new EducationService();
        if (this.props.PhysiotherapistId) {
            educationService.GetPhysiotherapistsEducation(
                this.props.PhysiotherapistId,
                this.OnGetEducationSuccess,
                this.OnGetEducationError);
        } else {
            educationService.GetMyEducation(this.OnGetEducationSuccess, this.OnGetEducationError);
        }
    }

    private OnGetEducationSuccess(result) {
        this.setState({
            Education: result.data.Value
        });
    }

    private OnGetEducationError(error) {
        console.error(error);
    }

    private RefreshDiseaseCategories() {
        let diseaseCategoryService = new DiseaseCategoryService();
        if (this.props.PhysiotherapistId) {
            diseaseCategoryService.GetPhysiotherapistsDiseaseCategories(
                this.props.PhysiotherapistId,
                this.OnGetDiseaseCateogoriesSuccess,
                this.OnGetDiseaseCateogoriesError);
        } else {
            diseaseCategoryService.GetMyDiseaseCategoriesList(
                this.OnGetDiseaseCateogoriesSuccess,
                this.OnGetDiseaseCateogoriesError);
        }
    }

    private OnGetDiseaseCateogoriesSuccess(result) {
        this.setState({
            DiseaseCategories: result.data.Value
        });
    }

    private OnGetDiseaseCateogoriesError(error) {
        console.error(error);
    }

    private RefreshInternships() {
        let service = new InternshipService();
        if (this.props.PhysiotherapistId) {
            service.GetPhysiotherapistsInternships(
                this.props.PhysiotherapistId,
                this.OnGetInternshipsSuccess,
                this.OnGetInternshipsError);
        } else {
            service.GetMyInternships(this.OnGetInternshipsSuccess, this.OnGetInternshipsError);
        }
    }

    private OnGetInternshipsSuccess(result) {
        this.setState({
            Internships: result.data.Value
        });
    }

    private OnGetInternshipsError(error) {
        console.error(error);
    }

    private RefreshTrainingCourses() {
        let trainingCourseService = new TrainingCourseService();
        if (this.props.PhysiotherapistId) {
            trainingCourseService.GetPhysiotherapistsTrainingCourses(
                this.props.PhysiotherapistId,
                this.OnGetTrainingCoursesSuccess,
                this.OnGetTrainingCoursesError);
        } else {
            trainingCourseService.GetMyTrainingCourses(this.OnGetTrainingCoursesSuccess, this.OnGetTrainingCoursesError);
        }
    }

    private OnGetTrainingCoursesSuccess(result) {
        this.setState({
            TrainingCourses: result.data.Value
        });
    }

    private OnGetTrainingCoursesError(error) {
        console.error(error);
    }

    private RefreshPhysiotherapistsBasicInfo() {
        let physiotherapistService = new PhysiotherapistService();
        if (this.props.PhysiotherapistId) {
            physiotherapistService.GetPhysiotherapist(this.props.PhysiotherapistId, this.OnGetBasicInfoSuccess, this.OnGetBasicInfoError);
        } else {
            physiotherapistService.GetCurrentPhysiotherapist(this.OnGetBasicInfoSuccess, this.OnGetBasicInfoError);
        }
    }

    private OnGetBasicInfoSuccess(result) {
        this.setState({
            AboutMe: result.data.Value.AboutMe,
            Specialization: result.data.Value.Specialization
        });
    }

    private OnGetBasicInfoError(error) {
        console.error(error);
    }
}


// WEBPACK FOOTER //
// ./src/components/PhysiotherapistView/PhysiotherapistInfo.tsx